import { api } from '@/common/api/axios.ts'
import type { IBlockContactFormRequest } from '@/features/block-contact-form/types/IBlockContactFormRequest.ts'

export const sendBlockContactForm = (sendBlockContactForm: IBlockContactFormRequest) => {
  return api.post('/contact/send', sendBlockContactForm)
}
